import styled from '@emotion/styled'
import { Accordion, AccordionProps } from '@mui/material'
import { theme } from 'styles/theme/hav-theme'

interface AccordionStyledProps extends AccordionProps {
  height: number
  width: string
}

export const AccordionStyled = styled(Accordion)<AccordionStyledProps>`
  height: ${({ height }) => height};
  width: ${({ width }) => width};
  position: relative;
  font-family: ${theme.typography.family.primary};

  & + & {
    margin-top: ${theme.spacing.lg};
  }

  border-radius: ${theme.shapes.borderRadius.sm};
  box-shadow: ${theme.effects.boxShadow['rule-01']};
  border: 1px solid ${theme.colors.neutral.lighthover};
  padding: ${theme.spacing.xm};
  margin: 0;

  @media (max-width: ${theme.breakpoints.lg}px) {
    padding: ${`
      ${theme.spacing.md}
      ${theme.spacing.sm}
      ${theme.spacing.md}
      ${theme.spacing.sm}`};
  }

  .error {
    width: 100%;
    margin: ${theme.spacing.lg} 0 0 0;
  }

  :before {
    background-color: transparent;
  }

  .MuiAccordionSummary-root {
    padding: 0;
    min-height: auto !important;
  }
  :before {
    background-color: transparent;
  }

  .MuiAccordionSummary-contentGutters {
    margin: 0;
  }

  .Mui-expanded .MuiAccordionSummary-contentGutters {
    margin: 0;
    height: auto;
  }
  .MuiAccordionSummary-content {
    display: flex;
    flex-direction: column;
  }
  .MuiAccordionSummary-expandIconWrapper {
    position: absolute;
    top: 0px;
    right: 0px;
  }
  .MuiAccordionDetails-root {
    border-top: ${`${theme.shapes.borderWidth.thin} ${theme.colors.neutral.light}`};
    padding: 0;
    padding-top: ${theme.spacing.lg};
    margin-top: ${theme.spacing.lg};
    @media (max-width: ${theme.breakpoints.md}px) {
      padding-top: ${theme.spacing.md};
      margin-top: ${theme.spacing.md};
    }
  }

  .MuiAccordionSummary-root .MuiSvgIcon-root {
    font-size: ${theme.icon.size.big};
    fill: ${theme.colors.primary.main};
    @media (max-width: ${theme.breakpoints.md}px) {
      font-size: ${theme.icon.size.x.medium};
    }
  }
`

export const AccordionSummaryContent = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-wrap: wrap;
  margin-top: ${theme.spacing.xs};
`

export const AccordionSummaryBoxWrapper = styled.div`
  display: flex;
  flex-basis: 50%;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 35px;
`
export const AccordionSummaryBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: ${theme.spacing.lg};
  gap: ${theme.spacing.xs};

  h1 {
    font-size: ${theme.typography.sizes.xs};
    margin: 0;

    span {
      color: ${theme.colors.neutral.light};
    }
  }

  h2,
  h3 {
    font-size: ${theme.typography.sizes.sm};
    color: ${theme.colors.neutral.black};
    margin: 0;
  }

  h1,
  h2 {
    font-weight: ${theme.typography.weight.lg};
  }

  h3 {
    color: ${theme.colors.neutral.medium};
    font-weight: ${theme.typography.weight.sm};
  }

  &.firstElement {
    flex: 1;
    color: ${theme.colors.neutral.black};
    h1 {
      font-size: ${theme.typography.sizes.sm};
    }
    h1,
    h2,
    h3 {
      font-weight: ${theme.typography.weight.lg};
    }
  }
`

export const AccordionMainContent = styled.div`
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  border-bottom: ${`${theme.shapes.borderWidth.thin} ${theme.colors.neutral.light}`};
  padding-bottom: ${theme.spacing.lg};

  div {
    h1,
    h2 {
      margin: 0;
    }
    h1 {
      margin-bottom: ${theme.spacing.sm};
      font-size: ${theme.typography.sizes.xs};
    }
    h2 {
      font-weight: ${theme.typography.weight.sm};
      font-size: ${theme.typography.sizes.sm};
    }

    label {
      margin-bottom: ${theme.spacing.xs};
    }
  }

  @media (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: repeat(5, 1fr);
  }
`
export const WrapperError = styled.div`
  flex: 1;
  background: red;
`

export const MaterialCode = styled.div`
  display: flex;
  gap: ${theme.spacing.sm};
`

export const AttendedMaterialIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: ${theme.spacing.sm};
`

export const VariableGridBoxTag = styled.span`
  display: inline-flex;
  align-items: center;
  height: 19.61px;
  min-width: 122px;
  padding: 0 3px;
  background: ${theme.colors.neutral.white};
  border: 0.39px solid ${theme.colors.alert.info.dark};
  border-radius: 1.74px;
  font-family: inherit;
  box-sizing: border-box;
  font-size: ${theme.typography.sizes['2xs']};
  color: ${theme.colors.alert.info.dark};
  font-weight: ${theme.typography.weight.md};
  line-height: ${theme.spacing.xm};
`
